import { writable } from "svelte/store";
export const api = writable("https://api.dsaana.org/");
// export const api = writable("http://localhost/api/");
export const files = writable("https://api.dsaana.org/uploads/");
// export const files = writable("http://localhost/api/uploads/");
export const eventApi = writable("http://event.dsaana.org/repository/");
// export const eventApi = writable('http://127.0.0.1/FileManager/repository/')
